<div class="sig-table-wrap">
  <table class="sig-table">
    <thead>
      <tr>
        <th></th>
        <th>Score</th>
        <th>User</th>
        <th>Pages</th>
        <th class="sig-num">Duration</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="!isLoading">
        <tr *ngFor="let row of rows">
          <td>
            <button type="button" class="sig-view" (click)="view()">
              View
            </button>
          </td>
          <td>
            <span class="sig-score" [ngClass]="leadScoreClass(row.leadScore)">
              {{ row.leadScore }}
            </span>
          </td>
          <td [matTooltip]="row.user" matTooltipPosition="above">
            {{ row.userShort || "—" }}
          </td>
          <td>{{ row.pagesLength ? row.pagesLength : "—" }}</td>
          <td class="sig-num">{{ row.duration ? row.duration : "—" }}</td>
        </tr>
        <tr *ngIf="rows.length === 0">
          <td colspan="5" class="sig-empty">No signals yet</td>
        </tr>
      </ng-container>

      <ng-container *ngIf="isLoading">
        <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
          <td colspan="5">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '22px',
                width: '100%',
                margin: '0',
                'border-radius': '6px',
              }"
            ></ngx-skeleton-loader>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
